import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component'
import { CallbackComponent } from './callback.component'

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  // home
  { path: 'home', component: HomeComponent },

  // Orange Connect callback
  { path: 'callback', component: CallbackComponent },
  { path: 'gui/callback', component: CallbackComponent },
];
